export const TradingBlockEnvironments = {
    dashboard: 'dashboard',
    virtual: 'virtual',
};
//# sourceMappingURL=Environment.js.map